// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"6e06189a","397":"6cf165e0","456":"a6d79404","554":"6aebff42","891":"71141bd7","975":"b86e5a16","992":"79ce11ba","998":"86eeeeb2"}[chunkId] + ".chunk.js";
};